export const LOGGED_IN = 'LOGGED_IN';
export const UPDATE_TOKEN = 'UPDATE_TOKEN';
export const LOGOUT = 'LOGOUT';
export const GET_TOKEN = 'GET_TOKEN'